export const SEARCH_PRODUCT_GROUP = 'SEARCH_PRODUCT_GROUP';
export const SEARCH_PRODUCT_GROUP_SUCCESS = 'SEARCH_PRODUCT_GROUP_SUCCESS';
export const SEARCH_PRODUCT_GROUP_FAILURE = 'SEARCH_PRODUCT_GROUP_FAILURE';
export const SEARCH_PRODUCT_GROUP_CANCEL = 'SEARCH_PRODUCT_GROUP_CANCEL';
